import { EMPTY_STRING } from '../../../NonReact/constants/Common'
import { DEFAULT_CME_ID } from '../../AddUser/Constants'
import { ANY_NUMBER_OF_TELSYS_AVAILABLE } from '../Constants'
import { CMEDetailsData, CMEFormHookData } from '../Types'
import { APIData } from '../../../NonReact/common/Types/Types'

/**
 * CME default form data mapper.
 *
 * @param parentData The Parent data from JSON response.
 * @param usersCMEDetailsData The User data from JSON response.
 * @param filterCMEnvironmentID CME ID from the filter on the list page.
 */
const CMELoadDefaultDataMapper = (
    { Data: cmeData }: APIData<CMEDetailsData>,
    filterCMEnvironmentID: string
): CMEFormHookData => ({
    details: {
        description: EMPTY_STRING,
        id: EMPTY_STRING,
        billingid: EMPTY_STRING,
        parentcme: filterCMEnvironmentID ?? DEFAULT_CME_ID,
        providerids: EMPTY_STRING,
        disableAkixiLogin: false
    },
    domainProfile: {
        domain: cmeData.Domain ?? EMPTY_STRING,
        serveripaddress: cmeData.ServerIPAddress ?? EMPTY_STRING,
        tcpport: parseInt(cmeData.ServerTCPPort, 10) ?? 0,
        communicationactive: cmeData.CommunicationActivated ?? false,
        fromaddressemail: cmeData.FromAddressEmail ?? EMPTY_STRING,
        fromaddressname: cmeData.FromAddressName ?? EMPTY_STRING,
        companyname: cmeData.CompanyName ?? EMPTY_STRING,
        teamsappdownloadurl: cmeData.AppDownloadURL ?? EMPTY_STRING,
        cxiClientWindowsUrl: cmeData.CXIClientDownloadURLWin ?? EMPTY_STRING,
        cxiClientMacUrl: cmeData.CXIClientDownloadURLMac ?? EMPTY_STRING,
        searchAndCallUrl: cmeData.SearchAndCallAppDownloadURL ?? EMPTY_STRING,
        useauthentication: cmeData.UseAuthentication ?? false,
        username: cmeData.AuthUsername ?? EMPTY_STRING,
        password: cmeData.AuthPassword ?? EMPTY_STRING,
        cxiAccessCode: cmeData.CXIAccessCode ?? EMPTY_STRING
    },
    provisioning: {
        broadworks: {
            servicepacks: []
        }
    },
    licenseManagement: {
        EssentialsCap:
            cmeData?.LicenseCapManagement?.EssentialsCap === null
                ? EMPTY_STRING
                : `${cmeData?.LicenseCapManagement?.EssentialsCap}`,
        ProfessionalCap:
            cmeData?.LicenseCapManagement?.ProfessionalCap === null
                ? EMPTY_STRING
                : `${cmeData?.LicenseCapManagement?.ProfessionalCap}`,
        EnterpriseCap:
            cmeData?.LicenseCapManagement?.EnterpriseCap === null
                ? EMPTY_STRING
                : `${cmeData?.LicenseCapManagement?.EnterpriseCap}`,
        CallCentreAgentCap:
            cmeData?.LicenseCapManagement?.CallCentreAgentCap === null
                ? EMPTY_STRING
                : `${cmeData?.LicenseCapManagement?.CallCentreAgentCap}`,
        CallCentreSupervisorCap:
            cmeData?.LicenseCapManagement?.CallCentreSupervisorCap === null
                ? EMPTY_STRING
                : `${cmeData?.LicenseCapManagement?.CallCentreSupervisorCap}`,
        CXIntegrationCap:
            cmeData?.LicenseCapManagement?.CXIntegrationCap === null
                ? EMPTY_STRING
                : `${cmeData?.LicenseCapManagement?.CXIntegrationCap}`
    },
    capabilities: {
        maxTelsysCount: ANY_NUMBER_OF_TELSYS_AVAILABLE,
        cxaBroadworks: true,
        cxaWebex: true,
        cxaTeams: true,
        cxiBroadworks: true,
        cxiWebex: true,
        cxiTeams: true,
        legacyTelephony: true,
        legacy: true,
        enterprise: true
    }
})

export default CMELoadDefaultDataMapper
